import { JumioLogin } from './Login'
import { JumioOnboarding } from './Onboarding'
import { JumioRegistration } from './Registration'

export const JumioAuthService = {
  ...JumioRegistration,
  ...JumioOnboarding,
  ...JumioLogin,
}
